import axios from 'axios'
import {Message} from 'element-ui'
import router from '@/router'

//axios的默认基础路径
axios.defaults.baseURL = '/api'

//发送请求拦截器
axios.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

//响应拦截器
axios.interceptors.response.use(
  response => {
    //没有返回码的情况(原样返回)
    if(response.data.code === undefined){
      return response;
    }
    //标准接口返回结构
    else if (response.data.code === 200) {
      return response.data.data
    }
    //未登录，跳转到登录页
    else if(response.data.code === 401){
      router.push('/')
    }
    else {
      //错误信息提示
      if(response.data.message){
        Message.error(response.data.message)
      }
      return Promise.reject(response.data)
    }
  },
  error => {
    //错误信息提示
    Message.error(error.response.data.message)
    return Promise.reject(error)
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/js/http.js